import type { DroneEntity, DroneOtaEntity } from '@src/core/features';

export function droneNeedsOtaUpdate(ota: DroneOtaEntity | null | undefined): boolean {
  if (!ota) return false;
  return ota.updateRequired || ota.updateRecommended;
}

export function countDronesNeedingOtaUpdate(drones: DroneEntity[] | undefined): number {
  if (!drones?.length) return 0;
  return drones.reduce((count, drone) => count + (droneNeedsOtaUpdate(drone.ota) ? 1 : 0), 0);
}
